import { createOrgPath, postAListingPath } from '#/routing/routes';

import type { PostOnIdealistDropdownData } from './types/PostOnIdealistDropdownData';

export const postOnIdealistDropdownDataEn: PostOnIdealistDropdownData = {
  search: {
    title: 'Post',
    items: [
      {
        type: 'post-a-listing',
        title: 'Post a Listing',
        href: postAListingPath.with({}),
      },
      {
        type: 'create-org',
        title: 'Add your Organization',
        href: createOrgPath.with({}),
      },
    ],
  },
  resources: {
    title: 'Resources',
    items: [
      {
        type: 'employer-resources',
        title: 'Employer Resources',
        description:
          'Tools and advice to help you achieve your hiring and retention goals.',
        href: '/en/orgs/resources',
      },
      {
        type: 'volunteer-resources',
        title: 'Volunteer Engagement Resources',
        description:
          'Trainings and proven practices to help you successfully recruit and engage volunteers.',
        href: '/en/orgs/volunteer-engagement-resources',
      },
    ],
  },
};
